import { useTenantStore } from "@/store/tenant";
import { defineAsyncComponent, markRaw, computed, ComponentPublicInstance } from 'vue';


export default () => {
  interface ComponentList {
    [key: string]: () => Promise<any>;
  }
  const tenantStore = useTenantStore();

  // 组件加载器
  const loadComponent = (list: ComponentList) => computed(() => {
    const { theme, home, homeType } = tenantStore.themeConfig ?? {};
    const key = `${theme}-${home ? (home + '-') : ''}${homeType ?? 'GameType'}`;
    const components = list[key] || list['blue-default-GameType'] || null;
    if (components) {
      const asyncComponent = defineAsyncComponent(components);
      return markRaw(asyncComponent) as unknown as ComponentPublicInstance | null;
    }
    return null;
  });
  // 
  const tabsList: ComponentList = {
    'blue-default-GameType': () => import('@/views/tabbar/MainPage/components/Tabs/Tabs1/index.vue'),
    'blue-default-Platform': () => import('@/views/tabbar/MainPage/components/Tabs/Tabs4/index.vue'),
    'blue-default-v01-GameType': () => import('@/views/tabbar/MainPage/components/Tabs/Tabs5/index.vue'),
    'green-default-v01-GameType': () => import('@/views/tabbar/MainPage/components/Tabs/Tabs6/index.vue'),
    'green-default-v01-Platform': () => import('@/views/tabbar/MainPage/components/Tabs/Tabs6/index.vue'),
    'green-default-v02-Platform': () => import('@/views/tabbar/MainPage/components/Tabs/Tabs6/index.vue'),
  };
  const drawerLeftList: ComponentList = {
    'blue-default-GameType': () => import('@/views/tabbar/components/DrawerLeft/default/DrawerLeft1/index.vue'),
    'blue-default-Platform': () => import('@/views/tabbar/components/DrawerLeft/default/DrawerLeft2/index.vue'),
    'blue-default-v01-GameType': () => import('@/views/tabbar/components/DrawerLeft/default/DrawerLeft5/index.vue'),
    'green-default-v01-GameType': () => import('@/views/tabbar/components/DrawerLeft/default/DrawerLeft1/index.vue'),
    'green-default-v01-Platform': () => import('@/views/tabbar/components/DrawerLeft/default/DrawerLeft3/index.vue'),
    'green-default-v02-Platform': () => import('@/views/tabbar/components/DrawerLeft/default/DrawerLeft4/index.vue'),
  };

 
  const tabsComponent = loadComponent(tabsList);
  const drawerLeftComponent = loadComponent(drawerLeftList);


  return {
    tabsComponent,
    drawerLeftComponent
  }
}
